let proConfigMap = new Map([
  ["logoutUrl", "https://tex.poemhub.top"],
  ["loginUrl", "/infra/user/login"],
  ["regUrl", "/infra/user/reg"],
  ["baseAuthUrl","https://tex.poemhub.top"],
  ["accessTokenUrlPath","/infra/auth/access-token/refresh"],
  ["appHome","https://tex.poemhub.top"],
  ["appId" , "n29Pa29WS1"],
  ["refreshUserUrl","/infra/user/current-user"],
  ["compileBaseUrl","https://tex.poemhub.top/tex/static/proj"],
  ["tplBaseUrl","https://tex.poemhub.top/tex/static/tpl"],
  ["wssUrl","wss://ws.poemhub.top"],
  ["socketUrl","https://socket.poemhub.top/texhub"],
  ["shareBaseUrl","https://tex.poemhub.top/proj/share"],
  ["pdfScaleKey",""],
  ["pdfScrollKey","pdf:scroll:"],
  ["pdfCurPage","pdf:page:"],
  ["projActiveFile","proj:file:active:"],
  ["cfSiteKey","0x4AAAAAAANSWx3t0X_4XgDR"]
]); 

export default proConfigMap;